import { EGameType, ERoundStatus, IRound } from 'types/Round';

// Le backend est partagé avec le front Tsipika : un round sans gameType
// (undefined) est Faritany par défaut côté serveur, donc inclus ici.
export const isFaritanyRound = (round: IRound): boolean =>
  round.gameType == null || round.gameType === EGameType.FARITANY;

export const isPublicWaitingRound = (round: IRound): boolean =>
  round.status === ERoundStatus.NOT_STARTED &&
  !round.invitationFor &&
  !round.invited &&
  isFaritanyRound(round);

export const filterPublicLobbyRounds = (rounds: IRound[]): IRound[] =>
  rounds.filter(isPublicWaitingRound);
